var $26ed5517fc7f946e$exports = {};
$26ed5517fc7f946e$exports = {
    "backButton": (args)=>`Sp\xe4\u{165} na ${args.prevMenuButton}`,
    "moreActions": `\u{10E}al\u{161}ie akcie`,
    "unavailable": `Nedostupn\xe9, rozba\u{13E}te podrobnosti`
};


export {$26ed5517fc7f946e$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
